import { Routes } from '@angular/router';
import { authGuard, guestGuard, permissionGuard } from './core/guards';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    title: 'تسجيل الدخول — انفينتو',
    loadComponent: () => import('./features/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [guestGuard],
    title: 'استعادة كلمة المرور — انفينتو',
    loadComponent: () =>
      import('./features/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    // Reached from a reset link, so it must work for a signed-out operator — and for one who
    // is still signed in elsewhere, which is why it is not behind the guest guard.
    path: 'reset-password',
    title: 'تعيين كلمة مرور — انفينتو',
    loadComponent: () =>
      import('./features/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'نظرة عامة — انفينتو',
        loadComponent: () => import('./features/overview.component').then((m) => m.OverviewComponent),
      },
      {
        path: 'metric-groups',
        canActivate: [permissionGuard('metrics.view')],
        title: 'مجموعات المعايير — انفينتو',
        loadComponent: () =>
          import('./features/metric-groups.component').then((m) => m.MetricGroupsComponent),
      },
      {
        path: 'usage-metrics',
        canActivate: [permissionGuard('metrics.view')],
        title: 'معايير الاستخدام — انفينتو',
        loadComponent: () =>
          import('./features/usage-metrics.component').then((m) => m.UsageMetricsComponent),
      },
      {
        path: 'plans',
        canActivate: [permissionGuard('plans.view')],
        title: 'الخطط والتسعير — انفينتو',
        loadComponent: () => import('./features/plans.component').then((m) => m.PlansComponent),
      },
      {
        path: 'customers',
        canActivate: [permissionGuard('customers.view')],
        title: 'العملاء — انفينتو',
        loadComponent: () => import('./features/customers.component').then((m) => m.CustomersComponent),
      },
      {
        path: 'subscriptions',
        canActivate: [permissionGuard('subscriptions.view')],
        title: 'الاشتراكات — انفينتو',
        loadComponent: () =>
          import('./features/subscriptions.component').then((m) => m.SubscriptionsComponent),
      },
      {
        path: 'invoices',
        canActivate: [permissionGuard('invoices.view')],
        title: 'الفواتير — انفينتو',
        loadComponent: () => import('./features/invoices.component').then((m) => m.InvoicesComponent),
      },
      {
        path: 'credit-notes',
        canActivate: [permissionGuard('creditnotes.view')],
        title: 'الإشعارات الدائنة — انفينتو',
        loadComponent: () =>
          import('./features/credit-notes.component').then((m) => m.CreditNotesComponent),
      },
      {
        path: 'payments',
        canActivate: [permissionGuard('transactions.view')],
        title: 'الدفعات والحساب — انفينتو',
        loadComponent: () => import('./features/payments.component').then((m) => m.PaymentsComponent),
      },
      {
        path: 'integrations',
        canActivate: [permissionGuard('entitlements.view')],
        title: 'تكاملات المنتجات — انفينتو',
        loadComponent: () =>
          import('./features/integrations.component').then((m) => m.IntegrationsComponent),
      },
      {
        path: 'users',
        canActivate: [permissionGuard('users.view')],
        title: 'المستخدمون — انفينتو',
        loadComponent: () => import('./features/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'roles',
        canActivate: [permissionGuard('users.view')],
        title: 'الأدوار والصلاحيات — انفينتو',
        loadComponent: () => import('./features/roles.component').then((m) => m.RolesComponent),
      },
      {
        path: 'audit',
        canActivate: [permissionGuard('audit.view')],
        title: 'سجل العمليات — انفينتو',
        loadComponent: () => import('./features/audit.component').then((m) => m.AuditComponent),
      },
      {
        path: 'email',
        canActivate: [permissionGuard('settings.view')],
        title: 'البريد الصادر — انفينتو',
        loadComponent: () => import('./features/email.component').then((m) => m.EmailComponent),
      },
      {
        path: 'settings',
        canActivate: [permissionGuard('settings.view')],
        title: 'الإعدادات — انفينتو',
        loadComponent: () => import('./features/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: 'profile',
        title: 'حسابي — انفينتو',
        loadComponent: () => import('./features/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'notifications',
        title: 'الإشعارات — انفينتو',
        loadComponent: () =>
          import('./features/notifications.component').then((m) => m.NotificationsComponent),
      },
      {
        path: 'reports/financial',
        canActivate: [permissionGuard('invoices.view')],
        title: 'التقارير المالية — انفينتو',
        loadComponent: () =>
          import('./features/financial-reports.component').then((m) => m.FinancialReportsComponent),
      },
      {
        path: 'products',
        canActivate: [permissionGuard('products.view')],
        title: 'المنتجات — انفينتو',
        loadComponent: () => import('./features/products.component').then((m) => m.ProductsComponent),
      },
      {
        path: 'sla',
        canActivate: [permissionGuard('sla.view')],
        title: 'اتفاقيات مستوى الخدمة — انفينتو',
        loadComponent: () => import('./features/sla.component').then((m) => m.SlaComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
